export default class DocResponse {

	public name: string = '';
	public data: string = '';
	public contentType: string = '';
	public policyName: string = '';

	public constructor() {

	}
};